module.exports = __webpack_public_path__ + "img/worksbot_img19112512.9d34900c.jpg";